define([], function() {
    
    
    /**
     * Abstract pseudo class for the creational process of 
     * the filter widgets.
     * 
     * @constructor
     * @param {Object} scope
     * @returns {_L1.WidgetFactory}
     */
    function WidgetFactory (scopes) {
        this._widgets = {};
        this._scopes = scopes;
        this._createWidgets();
        this._bindWidgetsToScope();
    }
    
    WidgetFactory.prototype = {
        
        /**
         * Creational process 
         * 
         * @returns {undefined}
         */
        _createWidgets: function() {
            throw "Implement WidgetFactory._createWidgets()";
        },
        
        /**
         * Bind created widgets to the scope
         * @return {undefined}
         */
        _bindWidgetsToScope: function() {
            throw "Implement WidgetFactory._bindWidgetsToScope()";
        },
        
        /**
         * Populates the this._widgets object
         * 
         * @param {String} name
         * @param {Object} widget
         * @returns {undefined}
         */
        set: function(name, widget) {
            this._widgets[name] = widget;
        },
        
        
        /**
         * Getter for this.widgets
         * 
         * @param {type} name
         * @returns {_L1.WidgetFactory._widgets}
         */
        get: function(name) {
            return this._widgets[name];
        },

        /**
         * Filter for this.widgets
         *
         * @param {Array} names
         * @returns {Array} of {_L1.WidgetFactory._widgets}
         */
        getList: function(names) {
            var result = [];
            var self = this;

            if (_.isArray(names)) {
                _.each(names, function(name) {
                    if (self._widgets[name]) {
                        result.push(self._widgets[name]);
                    }
                });
            } else {
                result = _.values(this._widgets);
            }

            return result;
        }
    };
    
    return WidgetFactory;
});


//////////////////
// WEBPACK FOOTER
// ./~/fcse-widget/widgetFactory.js
// module id = 185
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21